import React from 'react'
import Style from './connectorSteps.module.css'

export const CONNECTOR_STEP = {
    CHOOSE: 0,
    CONFIGURE: 1,
    INSTALL: 2
}

const STEPS = ['Choose source and target', 'Pick versions and features', 'Install and start syncing']

const ConnectorSteps = ({ current }) => (
    <ol className={Style.steps} aria-label="New connector progress">
        {STEPS.map((step, index) => {
            const state = index < current ? Style.stepDone : index === current ? Style.stepCurrent : ''
            return (
                <li key={step} className={[Style.step, state].join(' ')} aria-current={index === current ? 'step' : undefined}>
                    <span className={Style.stepNumber}>
                        {index < current ? <i className="uil-check" aria-hidden="true" /> : index + 1}
                    </span>
                    {step}
                </li>
            )
        })}
    </ol>
)

export default ConnectorSteps
